import { motion, useReducedMotion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { AnimatedIcon } from '@/shared/components/animated-icon';
import { rewardSentence } from '../../model/copy';
import type { MgmPublicRules } from '../../model/types';

/** "João te convidou!" — no topo do formulário de cadastro. */
export function ReferralBanner({ referrerFirstName, rules }: { referrerFirstName?: string; rules?: MgmPublicRules }) {
  const reduce = useReducedMotion();
  const benefit =
    rules?.referred.enabled
      ? rewardSentence('referred', rules.referred.amountText, rules.referred.trigger, 'referred')
      : 'Cadastre-se no programa de fidelidade e aproveite seus benefícios.';
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-4 flex items-center gap-3 rounded-2xl border border-primary/25 bg-primary/10 p-4"
      role="status"
    >
      <span className="grid size-11 shrink-0 place-items-center rounded-xl bg-primary text-primary-foreground shadow-soft">
        <AnimatedIcon icon={Gift} motion="wiggle" loop delay={0.4} className="size-5" />
      </span>
      <div className="min-w-0">
        <p className="font-semibold">
          {referrerFirstName ? `${referrerFirstName} te convidou!` : 'Você foi convidado!'}
        </p>
        <p className="text-sm text-muted-foreground">{benefit}</p>
      </div>
    </motion.div>
  );
}
